/* @ngInject */
function BoardItemController ($scope, $translate, $element, $timeout, UserService, ToastService, BoardsService, UdsModalService, ConfirmationModalService) {
  const getBoardFormDialogController = () => import('../../dialogs/board-form/board-form-dialog.controller')

  $scope.maxVisibleBoardMembers = 3
  $scope.tasksCount = {}
  $scope.boardFormDialogData = {
    editFormData: null
  }
  const api = {
    _getTasksCount,
    _successDuplicateBoard,
    _errorDuplicateBoard,
    _duplicateBoard
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getTasksCount($scope.board.id)
  }

  $scope.handleDuplicateBoard = () => {
    const boardId = $scope.board.id

    ConfirmationModalService.createModal({
      description: $translate.instant('workflow.duplicateBoard.confirmationModal.description'),
      buttonConfirmText: $translate.instant('workflow.duplicateBoard.confirmationModal.buttonConfirmText'),
      onConfirm: () => api._duplicateBoard(boardId)
    })
  }

  function _duplicateBoard (boardId) {
    return BoardsService.duplicateBoard(boardId)
      .then(api._successDuplicateBoard)
      .catch(api._errorDuplicateBoard)
  }

  function _successDuplicateBoard () {
    ToastService.showSuccessToast($translate.instant('workflow.duplicateBoard.toasts.success'))
    $scope.$emit('workflow.editedBoard')
  }

  function _errorDuplicateBoard () {
    ToastService.showErrorToast($translate.instant('workflow.duplicateBoard.toasts.error'))
  }

  $scope.getAvatarUrl = (user) => {
    if (!user || !user.id) return null
    return UserService.getUserProfileImage(user.id)
  }

  $scope.getAssigneesTooltip = (assignees) => {
    if (!assignees?.length) return

    let text = ''

    assignees.forEach((assignee) => {
      text += `${assignee.name}<br>`
    })

    $timeout(() => {
      jQuery($element).find('.designers-list-tooltip').popup({
        delay: {
          show: 1000,
          hide: 0
        }
      })
    }, 150, false)

    return text
  }

  $scope.openBoardSettings = function () {
    const board = $scope.board
    $scope.boardFormDialogData = {
      editFormData: board
    }
    getBoardFormDialogController().then(({ BoardFormDialogController }) => {
      const boardFormDialog = UdsModalService.createModal({
        controller: BoardFormDialogController,
        modalName: 'boardFormDialog',
        data: $scope.boardFormDialogData,
        onClose: (didUpdate) => {
          if (didUpdate) {
            $scope.$emit('workflow.editedBoard')
          }
        }
      })

      boardFormDialog.open()
    })
  }

  $scope.removeBoard = function (board) {
    ConfirmationModalService.createModal({
      title: $translate.instant('warning'),
      description: $translate.instant('areYouSureDeleteBoard'),
      buttonCancelText: $translate.instant('no'),
      buttonConfirmText: $translate.instant('yes'),
      onConfirm: () => {
        BoardsService.deleteBoard(board.id).then(() => {
          $scope.$emit('workflow.removedBoard')
        }).catch(ToastService.defaultErrorToast)
      }
    })
  }

  function _getTasksCount (boardId) {
    BoardsService.getTasksMetrics(boardId).then(result => {
      $scope.tasksCount.today = parseInt(result.today)
      $scope.tasksCount.overdue = parseInt(result.overdue)
    })
  }
}

export { BoardItemController }
